<template>
  <div class="appHeader u-borderBottom">
    <el-dropdown class="user u-fr" @command="onHandleCommand" placement="bottom-start">
      <p>
        <span>{{userName}}</span>
        <i class="el-icon-arrow-down el-icon--right"></i>
      </p>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="logout">退出</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <AppBread></AppBread>
  </div>
</template>

<script>
  // import store from '@/store';
  import { mapGetters } from 'vuex';
  
  import AppBread from './AppBread';
  
  // import { logout } from '@/api/user';
  
  export default {
    name: 'AppHeader',
    components: {
      AppBread
    },
    computed: {
      ...mapGetters([
        'userName'
      ])
    },
    methods: {
      onHandleCommand (command) {
        if (command === 'logout') {
          this.$router.push('/login');
          // if (!store.getters.jwt) {
          //   store.dispatch('logOut')
          //     .then(() => {
          //       this.$router.push('/login');
          //     });
          //   return;
          // }
          //
          // logout()
          //   .then(() => {
          //     store.dispatch('logOut')
          //       .then(() => {
          //         this.$router.push('/login');
          //       });
          //   });
        }
      }
    }
  };
</script>

<style lang="scss">
  @import "@/styles/_variables.scss";
  
  .appHeader {
    p {
      margin-right: 38px;
      line-height: $headerH;
      color: $blue;
      cursor: pointer;
    }
  }
</style>
